import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { useDesignVersionPath } from '@/hooks'

import NavigationLabel from '../../NavigationLabel/NavigationLabel'
import { NAVIGATION_LABELS } from '../../../helpers/constants'

const SurveysLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  const surveysPath = useDesignVersionPath('surveys', {
    legacy: '/dashboard/survey/legacy',
    new: '/dashboard/survey',
  })

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={withUpsellingRedirect ? '/dashboard/upselling/communicate' : surveysPath}
      >
        <span>
          {t('navbar:upsellingLinks.surveys')}
          <NavigationLabel type={NAVIGATION_LABELS.NEW} locked={Boolean(withUpsellingRedirect)} />
        </span>
      </NavLink>
    </div>
  )
}

SurveysLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default SurveysLink
